<div class="error-page">
	<h1>Something went wrong</h1>
	<p>We couldn't load this page. Please try again or return to the home page.</p>
	<a routerLink="/report">Go to home</a>
</div>
